import _ from 'underscore';
import { ColumnsConfigBuilder } from '@bingads-webui-campaign/summary-grid-helper';
import { TargetingSettingsContext } from '@bingads-webui-campaign/targeting-settings-scaffolds';
import { BudgetColumn } from '@bingads-webui-campaign/campaignui-common-columns';
import { TrackingTemplateColumn, CustomParametersColumn, FinalUrlSuffixColumn } from '@bingads-webui-campaign/tracking-template-columns';
import { ColumnCampaign } from './columns/campaign-column';
import { ColumnLocations } from './columns/locations-column';
import { ColumnAdSchedule } from './columns/ad-schedule-column';
import { ColumnDevices } from './columns/devices-column';
import { ColumnDemographic } from './columns/demographic-column';
import { ColumnStatus } from './columns/status-column';
import { inlineEditableSave } from './columns/inline-editable/save';

export default class SettingsGridColumnsConfig {
  constructor(deps) {
    const {
      view,
      permissions,
    } = deps;
    let columns = [
      ColumnCampaign,
      BudgetColumn,
      ColumnLocations,
      ColumnDevices,
      ColumnAdSchedule,
      ColumnDemographic,
      TrackingTemplateColumn,
      CustomParametersColumn,
      FinalUrlSuffixColumn,
    ];

    this.permissions = permissions;
    this.view = view;
    columns = _.compact(columns);

    this.builder = new ColumnsConfigBuilder()
      .addCategory('CampaignSettings', category => category.addColumns(columns));

    this.builder
      .setLockedColumns([ColumnStatus, ColumnCampaign])
      .setSelectedColumns(columns.concat([ColumnStatus]));
  }

  getColumnsConfig() {
    return this.builder.getColumnsConfig({
      i18n: TargetingSettingsContext.i18n,
      view: this.view,
      inlineEditableSave,
      permissions: this.permissions,
      schemaI18n: TargetingSettingsContext.s$i18n,
      InlineSharedBudgetEditor: TargetingSettingsContext.InlineSharedBudgetEditor,
      InlineBudgetEditor: TargetingSettingsContext.InlineBudgetEditor,
      decimal: TargetingSettingsContext.decimal,
    });
  }

  getColumnChooserConfig() {
    return this.builder.getColumnChooserConfig({
      i18n: TargetingSettingsContext.i18n,
      patchQuery: true,
      Columns: TargetingSettingsContext.Columns,
      SelectedColumns: TargetingSettingsContext.SelectedColumns,
      LegacyColumns: TargetingSettingsContext.LegacyColumns,
      LegacySelectedColumns: TargetingSettingsContext.LegacySelectedColumns,
    });
  }
}
